import * as toastr from 'toastr';
import * as Sentry from "@sentry/react";

export default class ResponseHandler {

    public static onJson(r: Response): Promise<any> {
        if (!r.ok) {
            this.onError(r);
        }

        return r.json();
    }

    public static onError(e: Response): any {
        
        console.error(e);
        Sentry.captureException(e); 

        toastr.error(e.statusText, e.statusText, {
            tapToDismiss: true,
            timeOut: 5000
        });

        return Promise.reject(e);
    }
}
